"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _keyCodes = require("../utils/keyCodes");
var _events = _interopRequireDefault(require("../utils/events"));
var _styles = require("./styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Overlay = ({
  active = false,
  className = '',
  children = null,
  onClick = () => {},
  onEscKeyDown = () => {},
  testId
}) => {
  (0, _react.useEffect)(() => {
    const prevOverlayValue = document.body.style.overflow;
    const handleEscKey = e => {
      if (active && onEscKeyDown && e.code === _keyCodes.KEYBOARD_CODES.ESCAPE) {
        onEscKeyDown(e);
      }
    };
    _events.default.on(document.body, 'keydown', handleEscKey);
    document.body.style.overflow = active ? 'hidden' : prevOverlayValue;
    return () => {
      _events.default.off(document.body, 'keydown', handleEscKey);
      document.body.style.overflow = prevOverlayValue;
    };
  });
  return _react.default.createElement(_styles.OverlayContainer, {
    active: active,
    className: className,
    "data-test-id": testId
  }, _react.default.createElement(_styles.Backdrop, {
    onClick: onClick
  }), children);
};
var _default = exports.default = Overlay;